import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AuthSource = "telegram" | "email" | "unauthorized";

export type TariffShort = {
  id: number;
  code: string;
  name: string;
  price: string;
  duration_days: number;
};

export type SubscriptionMe = {
  id: number;
  started_at: string;
  expires_at: string;
  auto_renew: boolean;
  is_active: boolean;
  tariff: TariffShort;
  config: string | null;
  config_url: string | null;
};

export type PaymentMethodMe = {
  payment_method_id: string;
  brand: string | null;
  last4: string | null;
  expiry_month: string | null;
  expiry_year: string | null;
  is_selected: boolean;
};

export type UserMe = {
  id: number | string;
  email: string | null;
  receipt_email: string | null;
  telegram_id: string | number | null;
  auth_provider: string;
  selected_payment_method_id: string | null;
  payment_methods: PaymentMethodMe[];
  subscription: SubscriptionMe | null;
};

interface AuthState {
  userId: string | null;
  authSource: AuthSource;

  accessToken: string | null;
  refreshToken: string | null;

  initData: string | null;

  me: UserMe | null;

  setInitData: (initData: string | null) => void;

  setTokens: (
    accessToken: string,
    refreshToken: string,
    source: AuthSource
  ) => void;

  setAccessToken: (accessToken: string) => void;

  setMe: (me: UserMe | null) => void;

  logout: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      userId: null,
      authSource: "unauthorized",

      accessToken: null,
      refreshToken: null,

      initData: null,

      me: null,

      setInitData: (initData) => set({ initData }),

      setTokens: (accessToken, refreshToken, authSource) =>
        set({
          accessToken,
          refreshToken,
          authSource,
        }),

      setAccessToken: (accessToken) => set({ accessToken }),

      setMe: (me) =>
        set({
          me,
          userId: me ? String(me.id) : null,
          authSource: me
            ? me.auth_provider === "telegram"
              ? "telegram"
              : "email"
            : "unauthorized",
        }),

      logout: () =>
        set({
          userId: null,
          authSource: "unauthorized",
          accessToken: null,
          refreshToken: null,
          me: null,
        }),
    }),
    {
      name: "auth-store",
    }
  )
);
